import { AppModel } from '../../constants/api';
import { useApp, useStore } from '../../store/appStores';

export const useCurrentTpv = () => {
  const tpvs = useStore(AppModel.TPV);
  const selectedTpv = useApp((s) => s.selectedTpv);

  return tpvs.find((x) => x._id === selectedTpv) ?? null;
};
